/* Boss Granola – flying ingredient explosion (home page product cards) */
(function () {
  var W = 1080, H = 1350, SMIN = 0.15, SMAX = 3.2, LS = Math.log(SMAX / SMIN);
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || window.__bossExplosionAnim) return;
  window.__bossExplosionAnim = true;

  function loadImg(src) {
    return new Promise(function (res, rej) {
      var i = new Image(); i.decoding = 'async';
      i.onload = function () { res(i); }; i.onerror = rej; i.src = src;
    });
  }
  function mk(w, h) { var c = document.createElement('canvas'); c.width = Math.max(1, Math.round(w)); c.height = Math.max(1, Math.round(h)); return c; }
  function rng(seed) { return function () { seed |= 0; seed = seed + 0x6D2B79F5 | 0; var t = Math.imul(seed ^ seed >>> 15, 1 | seed); t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t; return ((t ^ t >>> 14) >>> 0) / 4294967296; }; }
  function path(pts, ox, oy, k) {
    var p = new Path2D();
    for (var i = 0; i < pts.length; i += 2) { var x = (pts[i] - ox) * k, y = (pts[i + 1] - oy) * k; i ? p.lineTo(x, y) : p.moveTo(x, y); }
    p.closePath(); return p;
  }
  var canFilter = (function () { try { var c = mk(2, 2).getContext('2d'); c.filter = 'blur(2px)'; return c.filter === 'blur(2px)'; } catch (e) { return false; } })();

  function place(canvas) {
    // sit exactly over the visible (object-fit: contain) picture
    var img = canvas.parentElement.querySelector('img');
    if (!img) return;
    var b = canvas.parentElement.getBoundingClientRect(), r = img.getBoundingClientRect();
    var cw = Math.min(r.width, r.height * W / H), ch = cw * H / W;
    canvas.style.left = (r.left - b.left + (r.width - cw) / 2) + 'px';
    canvas.style.top = (r.top - b.top + (r.height - ch) / 2) + 'px';
    canvas.style.width = cw + 'px'; canvas.style.height = ch + 'px';
  }
  function init(canvas) {
    var box = canvas.parentElement;
    place(canvas);
    window.addEventListener('resize', function () { place(canvas); });
    var S = canvas.width / W; // drawing scale (canvas may be smaller than 1080 wide)
    Promise.all([
      fetch(canvas.dataset.json).then(function (r) { return r.json(); }),
      loadImg(canvas.dataset.bg),
      loadImg(canvas.dataset.photo)
    ]).then(function (res) {
      var d = res[0], bg = res[1], photo = res[2];
      var full = mk(W, H), fx = full.getContext('2d');
      fx.drawImage(bg, -d.cover[2], -d.cover[3], d.cover[0], d.cover[1]);
      return loadImg(d.plate).then(function (tiny) {
        // fully opaque glowing backdrop (redrawn every frame, so nothing can smear)
        var plate = mk(canvas.width, canvas.height), px = plate.getContext('2d');
        px.imageSmoothingQuality = 'high';
        px.drawImage(tiny, 0, 0, plate.width, plate.height);
        if (canFilter) {
          var t2 = mk(plate.width, plate.height), tx = t2.getContext('2d');
          tx.drawImage(plate, 0, 0);
          tx.filter = 'blur(' + Math.round(18 * S) + 'px)';
          tx.drawImage(plate, -40, -40, plate.width + 80, plate.height + 80);
          plate = t2;
        }
        var R = rng(4), parts = [];
        d.pieces.forEach(function (pts) {
          var x0 = 1e9, y0 = 1e9, x1 = -1e9, y1 = -1e9;
          for (var i = 0; i < pts.length; i += 2) { x0 = Math.min(x0, pts[i]); x1 = Math.max(x1, pts[i]); y0 = Math.min(y0, pts[i + 1]); y1 = Math.max(y1, pts[i + 1]); }
          x0 -= 2; y0 -= 2; x1 += 2; y1 += 2;
          var sw = x1 - x0, sh = y1 - y0, s = mk(sw, sh), sx = s.getContext('2d');
          sx.clip(path(pts, x0, y0, 1)); sx.drawImage(full, -x0, -y0);
          var cx = (x0 + x1) / 2 - W / 2, cy = (y0 + y1) / 2 - H / 2, r = Math.hypot(cx, cy) || 1;
          for (var rep = 0; rep < 3; rep++) {
            var ang = rep ? (R() * 2 - 1) * Math.PI : 0, ca = Math.cos(ang), sa = Math.sin(ang);
            var dx = cx / r, dy = cy / r, len = 360 * (0.6 + 0.8 * R());
            var pw0 = sw * (rep ? 0.75 + 0.45 * R() : 1);
            parts.push({ s: s, w: pw0, h: pw0 * sh / sw, flip: rep && R() < 0.5,
              dx: (dx * ca - dy * sa) * len, dy: (dx * sa + dy * ca) * len,
              T: [6, 12, 12][Math.floor(R() * 3)], u0: R() });
          }
        });
        var P = d.pouch, bb = P.bbox, k = photo.naturalWidth / 1350;
        var ph = Math.round(H * 0.66), kk = ph / bb[3], pw = bb[2] * kk;
        var pouch = mk(pw, ph), pc = pouch.getContext('2d');
        pc.clip(path(P.pts, bb[0], bb[1], kk));
        pc.drawImage(photo, -bb[0] * kk, -bb[1] * kk, photo.naturalWidth / k * kk, photo.naturalHeight / k * kk);
        var shadow = mk(pw + 160, ph + 160), sc = shadow.getContext('2d');
        if (canFilter) sc.filter = 'blur(28px)';
        sc.drawImage(pouch, 80, 80); sc.filter = 'none'; sc.globalCompositeOperation = 'source-in'; sc.fillStyle = '#000'; sc.fillRect(0, 0, shadow.width, shadow.height);
        var pX = (W - pw) / 2, pY = Math.round(H * 0.185);

        var ctx = canvas.getContext('2d', { alpha: false }), visible = false, running = false, start = performance.now();
        function draw(now) {
          if (!visible) { running = false; return; }
          var t = (now - start) / 1000;
          ctx.setTransform(1, 0, 0, 1, 0, 0);
          ctx.globalAlpha = 1;
          ctx.drawImage(plate, 0, 0);
          ctx.setTransform(S, 0, 0, S, 0, 0);
          var items = parts.map(function (p) { var u = (p.u0 + t / p.T) % 1; return [SMIN * Math.exp(LS * u), u, p]; });
          items.sort(function (a, b) { return a[0] - b[0]; });
          for (var i = 0; i < items.length; i++) {
            var scl = items[i][0], u = items[i][1], p = items[i][2];
            var w = p.w * scl, h = p.h * scl;
            var x = W / 2 + p.dx * scl, y = H / 2 + p.dy * scl;
            if (x + w / 2 < 0 || x - w / 2 > W || y + h / 2 < 0 || y - h / 2 > H) continue;
            ctx.globalAlpha = Math.min(1, u / 0.15);
            if (p.flip) { ctx.save(); ctx.translate(x, y); ctx.scale(-1, 1); ctx.drawImage(p.s, -w / 2, -h / 2, w, h); ctx.restore(); }
            else ctx.drawImage(p.s, x - w / 2, y - h / 2, w, h);
          }
          ctx.globalAlpha = 0.55; ctx.drawImage(shadow, pX - 80 + 18, pY - 80 + 28); ctx.globalAlpha = 1;
          ctx.drawImage(pouch, pX, pY + 6 * Math.sin(2 * Math.PI * t / 3));
          requestAnimationFrame(draw);
        }
        function go() { if (visible && !running) { running = true; requestAnimationFrame(draw); } }
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (e) { visible = e[0].isIntersecting; go(); }).observe(canvas);
        } else { visible = true; go(); }
        box.classList.add('anim-ready');
      });
    }).catch(function (e) { if (window.console) console.warn('explosion anim', e); });
  }

  function boot() {
    var list = document.querySelectorAll('[data-explosion-anim]');
    if (!('IntersectionObserver' in window)) { list.forEach(init); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { io.unobserve(en.target); init(en.target); } });
    }, { rootMargin: '300px' });
    list.forEach(function (c) { io.observe(c); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
